import { Pipe, PipeTransform } from '@angular/core';
import { fiCustomerTypeName } from '../customer-billing-customer/customer-type';
import { AppTextService } from '@fi-shared/app-text';

@Pipe({
    name: 'fiCustomerTypeName',
    standalone: false,
})
export class CustomerTypeNamePipe implements PipeTransform {
    constructor(private appText: AppTextService) {}

    transform(value: any, args?: any): any {
        return fiCustomerTypeName(value, this.appText);
    }
}
